import produce from "immer";
import React, {
  FC,
  createContext,
  useContext,
  useState,
  useEffect,
} from "react";
import { useDispatch, useSelector} from "react-redux";
import { startLoadProjectSession } from "../actions/projectAction";
import { setSession } from "../actions/sessionListAction";
import { UserModal } from "../models/userModel";
import { getSession } from "../selectors/appSelectors";
import userService from "../services/userService";

interface IAuthContext {
  authData: UserModal | undefined;
  isAuthenticate: boolean;
  isLoading : boolean;
  login: (userName: string, token: string) => void;
  logout: () => void;
  checkAuth: () => void;
}

const AuthContext = createContext<IAuthContext>({
  authData: undefined,
  isAuthenticate: localStorage.getItem("user") ? true : false,
  isLoading : true,
  login: async () => {},
  logout: async () => {},
  checkAuth: async () => {},
});

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider: FC = ({ children }) => {
  const [authState, setAuthState] = useState<UserModal>();
  const [isAuthenticate, setIsAuthenticate] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const sessionState = useSelector(getSession);
  const dispatch = useDispatch();
  const checkUser = async () => {
    const user = localStorage.getItem("user");
    if (user && user != "" && user != undefined) {
      let userObject = JSON.parse(user);
      setAuthState(userObject);
    }
    setIsLoading(false)
  };


  const setLogin = async (userName: string, token: string) => {
    const { data } = await userService.checkAuth({
      userName: userName,
      token: token,
    });
    if (data && data.data !== null) {
      setAuthState({
        userName: data.data!.userName,
        authToken: data.data!.authToken,
      });
      const newSessionState = produce(sessionState, draft => { draft.selectedProjectId = data.data!.selectedProjectId; draft.selectedFormId = data.data!.selectedFormId});
      localStorage.setItem('session', JSON.stringify(newSessionState));
      localStorage.setItem("user", JSON.stringify({userName: data.data!.userName, authToken: data.data!.authToken}));
      localStorage.setItem("selectedProjectId", data.data!.selectedProjectId);
      localStorage.setItem("selectedFormId", data.data!.selectedFormId);
      localStorage.setItem("userRoleId", data.data!.userRoleId);
      setIsAuthenticate(true);
    }
    setIsLoading(false)
  };

  const setLogOut = async () => {
    setAuthState(undefined);
    setIsAuthenticate(false);
    localStorage.removeItem("user");
    localStorage.removeItem("form");
    localStorage.removeItem("session");
    localStorage.removeItem("selectedFormId");
    localStorage.removeItem("selectedProjectId");
    localStorage.removeItem("userRoleId");
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user && user != "" && user != undefined) {
      let userObject = JSON.parse(user);
      setAuthState(userObject);
      setIsAuthenticate(true);
    }
    const session = localStorage.getItem("session");
    // if (user && session && session != "" && session != undefined) {
    //   let sessionObject = JSON.parse(session);
    //   let userObject = JSON.parse(user);
    //   // if(sessionObject.selectedProjectId)
    //   // {
    //   //   dispatch(startLoadProjectSession(userObject.userName,sessionObject.selectedProjectId,sessionObject.selectedFormId))
    //   // }
    //   dispatch(setSession(sessionObject));
    // }
    setIsLoading(false)
  }, []);

  return (
    <AuthContext.Provider
      value={{
        authData: authState,
        isAuthenticate : isAuthenticate,
        isLoading : isLoading,
        login: (userName: string, token: string) => setLogin(userName, token),
        logout: () => setLogOut(),
        checkAuth: () => checkUser(),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
